/**
 * Test mode for the AI cancellation chat: transcripts still persist (marked
 * `is_test`), but PostHog cancel-chat events are suppressed and subscription
 * mutations short-circuit so localhost / internal sessions cannot change real
 * accounts. Default-on for localhost; also on with ?so_cancel_chat_test=1 or the
 * existing ?so_cancel_chat=1 force-chat override. ?so_cancel_chat_test=0 forces
 * off even on localhost.
 */

import { hasCancelChatOverride } from "./cancel-chat-override";

const TEST_STORAGE_KEY = "so_cancel_chat_test";

export function parseCancelChatTestParam(search: string): boolean | null {
  const value = new URLSearchParams(search).get("so_cancel_chat_test");
  if (value === "1" || value === "true") return true;
  if (value === "0" || value === "false") return false;
  return null;
}

function isLocalhostHostname(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

export function isCancelChatTestMode(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const fromParam = parseCancelChatTestParam(window.location.search);
    if (fromParam === true) {
      sessionStorage.setItem(TEST_STORAGE_KEY, "1");
      return true;
    }
    if (fromParam === false) {
      sessionStorage.setItem(TEST_STORAGE_KEY, "0");
      return false;
    }
    const stored = sessionStorage.getItem(TEST_STORAGE_KEY);
    if (stored === "1") return true;
    if (stored === "0") return false;
    if (hasCancelChatOverride()) return true;
    return isLocalhostHostname(window.location.hostname);
  } catch {
    return isLocalhostHostname(window.location.hostname);
  }
}
